<template>
  <div class="faq-view__wrapper">
    <NavBar class="faq-view__nav" data-testid="navbar">
      <span slot="left">
        <BackButton data-testid="navbar-back-button" @click="onBackClick" />
      </span>
      <span slot="center">Me ajuda</span>
    </NavBar>
    <div
      class="faq-view__content"
      :class="{ 'faq-view__content--impersonate': isImpersonate }"
    >
      <SkeletonLoader v-if="isLoading" class="faq-view__content__loader">
        <div v-for="number in 5" :key="number" class="row-loader" />
      </SkeletonLoader>
      <div v-else>
        <div
          v-for="(module, validModulesIndex) in validModules"
          :key="validModulesIndex"
          class="faq-view__content__section"
        >
          <Heading data-testid="heading" :level="2">{{ module.name }}</Heading>
          <AccordionWrapper
            :data-testid="`accordion-wrapper-${validModulesIndex}`"
          >
            <Accordion
              v-for="(question, questionIndex) in module.questions"
              :key="questionIndex"
              :title="question.title"
              :is-primary="true"
            >
              <div data-testid="accordion-content" v-html="question.content" />
            </Accordion>
          </AccordionWrapper>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import {
  SkeletonLoader,
  Row,
  Heading,
  NavBar
} from '@warrenbrasil/nebraska-web';
import {
  AccordionWrapper,
  Accordion
} from '@/modules/common/components/Accordion';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { getFaq, IFaq } from '@/modules/help-center/services/faq';
import {
  isImpersonate,
  isWarrenManaged
} from '@/modules/common/services/partner';

interface IModule {
  type: string;
  name: string;
  questions: IFaq[];
}

@Component({
  components: {
    AccordionWrapper,
    SkeletonLoader,
    BackButton,
    Accordion,
    Heading,
    NavBar,
    Row
  }
})
export default class FAQView extends Vue {
  isLoading = true;
  isImpersonate = false;
  private modules: IModule[] = [
    {
      type: 'overview',
      name: 'Visão Geral',
      questions: []
    },
    {
      type: 'cash',
      name: 'Conta',
      questions: []
    },
    {
      type: 'portfolio_history',
      name: 'Carteiras',
      questions: []
    },
    {
      type: 'trade',
      name: 'Trade',
      questions: []
    }
  ];

  private async created() {
    this.isImpersonate = isImpersonate();
    const resp: any = await Promise.all(
      this.modules.map((module: IModule) => getFaq(module.type).catch(e => e))
    );
    this.modules.forEach((module: IModule, index: number) => {
      module.questions = this.filterQuestions(resp[index].questions || []);
    });
    this.isLoading = false;
  }

  onBackClick() {
    // @ts-ignore
    const backTo = this.$router.history.current.query.module || 'home';
    this.$router.push({ path: backTo });
  }

  private filterQuestions(questions: IFaq[]) {
    return isWarrenManaged()
      ? questions
      : questions.filter(
          faq => !faq.title.includes('Quanto custa investir com a Warren?')
        );
  }

  get validModules() {
    return this.modules.filter(module => module.questions.length > 0);
  }
}
</script>

<style lang="less" scoped>
@height-navbar: 64px;
.faq-view__wrapper {
  .faq-view__nav {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 20;
    * > {
      color: @text-primary !important;
    }
  }
  .faq-view__content {
    width: 100%;
    height: 100%;
    max-width: 1200px;
    min-height: calc(100vh - @height-navbar);
    margin: 0px auto;
    padding: @spacing-xxl @size-spacing-x400 0px;
    .faq-view__content__section {
      padding-bottom: @size-spacing-x800;
    }
    &.faq-view__content--impersonate {
      padding: calc(@spacing-xxl + @size-spacing-x300) @size-spacing-x400 0px;
    }
  }
}
.faq-view__content__loader {
  padding-top: @size-spacing-x800;
  .row-loader {
    height: 30px;
    margin: @size-spacing-x500 0;
    border-radius: 10px;
  }
}
</style>
